
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gSX3nE8IUiKU_HmOV2P7_45XW3_FYDZ1tdKMnYNpyUR3H0Meta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexes1mgoPKPFbnjiT7PlgNF4aJfm38gtEQA1cAK648mwcMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchpfUUk9a7NtK4O7Rp8AUANFtptD8lYsSnN7Xu6kucxF0Meta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index0ix6pA94XmO211kxtPcxCdykPgHjBziwi2ZB3evsux4Meta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93UvqASf9L5iEc0QNQdbJ_45Zx7DKORZkRGN9vHAypH3Af8Meta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indextxXYMI09iQGhpVrmSwJnaYInH8DYKvBMQ5utYwQc_45PoMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93OB4KCQDa13MAQ_70snR0ZwwTHY7zu9I0DtwideaoNxYMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexHW_451pMoVWbzWP8BMxfsdDFahFzBrLFss2ZY0nbCYt9sMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93K5dE2O16Ft0ThIKNXTVMPbF0GisPEwFOhDhoIhOhNSsMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexV9scdAHe5T1gEMKnNk7XkwhMG8E70viClule8u_45tS_45cMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexUx4dpEiIvBHjFYwluC2wxWUBCeEZ7ZNpzlmCfioXfbgMeta } from "/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indextxXYMI09iQGhpVrmSwJnaYInH8DYKvBMQ5utYwQc_45PoMeta || {},
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexHW_451pMoVWbzWP8BMxfsdDFahFzBrLFss2ZY0nbCYt9sMeta || {},
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexV9scdAHe5T1gEMKnNk7XkwhMG8E70viClule8u_45tS_45cMeta || {},
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexUx4dpEiIvBHjFYwluC2wxWUBCeEZ7ZNpzlmCfioXfbgMeta || {},
    component: () => import("/codebuild/output/src2490281754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]